import { memo } from 'react';
import { VStack, Text, HStack, Flex } from '@chakra-ui/react';

import ChevronIcon from 'shared/ChevronIcon';
import NextImage from 'shared/NextImage';

import line from 'assets/icons/stepsLine.svg';

const StepsCard = ({ step, src, title, text, isLineVisible = true }) => (
  <VStack
    pos="relative"
    align="start"
    justify="space-between"
    w={{ mobile: '340px', tablet: '310px', laptop: '440px', desktop: '590px' }}
    minH={{ mobile: '132px', tablet: '149px', laptop: '225px', desktop: '204px' }}
    gap={{ mobile: '24px', laptop: '32px' }}
  >
    <Flex w="full" pos="relative" py={{ mobile: '18px', laptop: '32px' }} justify="end">
      {isLineVisible && <NextImage src={line} alt="Линия" objectFit="contain" w="auto" h="auto" />}

      <HStack
        pos="absolute"
        top="0"
        left="0"
        bgColor="bg.black"
        borderRadius="full"
        spacing={{ mobile: '12px', laptop: '16px' }}
        p={{ mobile: '4px', laptop: '8px' }}
        pr={{ mobile: '20px', laptop: '32px' }}
      >
        <ChevronIcon
          src={src}
          p={{ laptop: '20px', tablet: '15px', mobile: '10px' }}
          boxSizing="border-box"
          bgColor="bg.white"
          boxSize={{ mobile: '32px', laptop: '52px' }}
          imageProps={{ minW: { mobile: '20px', laptop: '23px' } }}
        />

        <Text color="text.white" textStyle="h2" fontWeight="500">{`Шаг ${step}`}</Text>
      </HStack>
    </Flex>

    <VStack
      w="full"
      align="start"
      gap={{ laptop: '20px', mobile: '16px' }}
      maxW={{ mobile: '320px', tablet: '270px', laptop: '380px', desktop: '530px' }}
    >
      <Text as="h3" textStyle={{ mobile: 'header.h4', laptop: 'h4', desktop: 'header.h4' }}>
        {title}
      </Text>

      <Text as="p" textStyle="h2" fontWeight={{ mobile: 500, tablet: 400 }}>
        {text}
      </Text>
    </VStack>
  </VStack>
);

export default memo(StepsCard);
